import { Component, OnInit, ViewChild } from '@angular/core';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { FilterPipePipe } from '../../pipes/filter-pipe.pipe';
import { MatTableDataSource, MatSort, MatPaginator, MatSelect, MatOption } from '@angular/material';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { kpiCustData } from './kpiCustData';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import * as _moment from 'moment';

const moment = (_moment as any).default ? (_moment as any).default : _moment;

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY LT',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-soft-offering-reporting',
  templateUrl: './soft-offering-reporting.component.html',
  styleUrls: ['./soft-offering-reporting.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
    FilterPipePipe
  ],
})
export class SoftOfferingReportingComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  displayedColumns: string[] = [
    'customerName',
    'contactNo',
    'accountType',
    'softProductType',
    'registrationNo',
    'chassisNo',
    'dealerCode',
    'dealerName',
    'leadGenerationDate',
    'lastContacted',
    'leadStatus',
    'lastCallBy',
  ];

  spinner: boolean;
  userId: string;
  userInfo: any;
  today: Date = new Date();
  toDate: Date;
  fromDate: Date;
  isDateRangeInvalid = false;
  dataGridDataSource: any;
  selectWorkshop: FormGroup;
  filterValues: string[] = [];
  selectedFilter: string;
  workshopcodeFilter: string;
  splitworkshopcode: string[] = [];
  workshopFilter: string;
  workshopcode: string;
  filterValuesCopy: string[] = [];
  wsCodeFilter: string;
  dataSource: any;
  maxDate: Date = new Date();
  selectedDealer:any;
  dealerCode: string[] = [];
  selectedProductType: string;
  userRolesId: string;
  showPipelineDataReport: boolean = false
  productTypeValues: any[] = [
    { value: '1', viewValue: 'AMC'},
    { value: '2', viewValue: 'AMC Renewal'},
    { value: '3', viewValue: 'Insurance'},
    { value: '4', viewValue: 'Extended Warranty'}
  ];

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private toastr: ToastrService,
    private filterPipePipe: FilterPipePipe,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.setDefaultDates();
    this.userId = localStorage.getItem('userId');
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }
    this.userRolesId = JSON.parse(localStorage.getItem("userInfo"))[0].roleId;
    this.selectWorkshop = this.fb.group({
      workshopCodeType: new FormControl(this.filterValues),
      selectedDealer: ['']
    });

    if(this.userRolesId == "15"){
      this.showPipelineDataReport = true;
    }

    this.workshopCodeFilter();
  }

  /**
  * Name: workshopCodeFilter
  * purpose: To get workshop code filter
  */
  workshopCodeFilter(): void {
    this.filterValues = [];
    this.workshopcodeFilter;
    this.splitworkshopcode = [];
    this.workshopFilter;
    this.workshopcode;
    let roleId = this.userInfo['0'].roleId || '1';
    this.commonService.workshopFilter(this.userId, roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (res['responseData'].length) {
            res['responseData'].forEach(data => {
              this.workshopcodeFilter = data.workshop;
              this.workshopcode = (this.workshopcodeFilter.split(" ", 1)).toString();
              this.splitworkshopcode.push(this.workshopcode);
              this.filterValues.push(this.workshopcodeFilter);
            });
            this.selectedFilter = this.filterValues[0];
            this.workshopFilter = this.splitworkshopcode.toString();
            this.filterValuesCopy = this.filterValues;
            this.prepairCallList();
          }
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: prepairCallList
  * purpose: To prepare call list for dataGrid
  */
  prepairCallList(): void {
    // this.spinner = true;
    // let startdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    // let enddate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    // this.applyfilter();
    // this.commonService.amcDataGrid(startdate, enddate, this.wsCodeFilter)
    //   .subscribe(res => {
    //     if (res['responseCode'] == 0 && res['responseData'] != undefined) {
    //       if (res['responseData'].length) {
    //         this.dataSource = new MatTableDataSource<kpiCustData>(res['responseData']);
    //         this.dataSource.sort = this.sort;
    //         this.dataSource.paginator = this.paginator;
    //         this.spinner = false;
    //       }
    //     } else {
    //       this.spinner = false;
    //     }
    //   }, err => {
    //     this.spinner = false;
    //     this.toastr.error("Something went wrong, Please try again.", "Error");
    //   });
  }

  /**
  * Name: apply
  * purpose: To apply filter on datagrid
  */
  apply(): void {
    // this.spinner = true;
    // this.dataSource = '';
    // let startdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    // let enddate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    // this.applyfilter();
    // this.commonService.amcDataGrid(startdate, enddate, this.wsCodeFilter)
    //   .subscribe(res => {
    //     if (res['responseCode'] == 0 && res['responseData'] != undefined) {
    //       this.dataSource = new MatTableDataSource<kpiCustData>(res['responseData']);
    //       this.sort.direction = '';
    //       this.dataSource.sort = this.sort;
    //       this.dataSource.paginator = this.paginator;
    //       this.spinner = false;
    //     } else {
    //       this.spinner = false;
    //     }
    //   }, err => {
    //     this.spinner = false;
    //     this.toastr.error("Something went wrong, Please try again.", "Error");
    // });
  }

  /**
  * Name: applyfilter
  * purpose: To select and apply the selected workshopcode
  */
  applyfilter() {
    this.wsCodeFilter = '';
    this.selectedFilter;
    this.workshopFilter;
    if (this.selectedFilter != null) {
      let splitCode = [];
      //this.selectedFilter.forEach(data => {
        //if(data != '0'){
          splitCode.push((this.selectedFilter.split(" ", 1)).toString());
        //}
      //});
      this.wsCodeFilter = splitCode.toString();
    } else {
      this.wsCodeFilter = this.selectedFilter;
    }
    //this.wsCodeFilter = this.selectedFilter;
  }

  filterTriggered(event: any): void {
    this.today = new Date();
    if((new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30))).getTime() >= this.today.getTime()){
      this.today = new Date();
      if((new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30))).getTime() >= this.today.getTime()){
        this.toDate = new Date();
      } else {
         this.toDate = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
      }
    } else {
      this.today = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
      this.toDate = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
    }
  }

  onKey() : void {
    this.filterValues = this.filterValuesCopy;
    this.dealerCode = [];
    this.selectedDealer = this.selectWorkshop.controls.selectedDealer.value;
    this.selectedDealer = this.selectedDealer.toString();
    this.dealerCode = this.filterValues.filter(item =>
      item.toLowerCase().includes(this.selectedDealer.toLowerCase())
    );
    if(this.dealerCode.length > 0){
      this.closeInput();
    }
    this.filterValues = [];
    this.filterValues = this.dealerCode;
  }

  closeInput() : void {
    if(this.dealerCode.length == 0) {
     //this.selectedDealer = '';
     this.selectWorkshop.controls["selectedDealer"].setValue("");
     this.filterValues = this.filterValuesCopy;
    }
  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on datagrid
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataGridDataSource.filter = filterValue;
  }

  /**
   * Name: activeButton
   * purpose: To activat Booking Excel Report button
   */
  activeButton(): boolean {
    let flag = false;
    if (this.selectedProductType != undefined && this.selectedProductType != null && this.selectedProductType != '') {
      flag = true;
    }
    return flag;
  }

  /**
  * Name: getDataReport
  * purpose: To export report as excel
  */
  getDataReport(): void {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let startdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let enddate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let fileName = "Summary_From_" + startdate + "_To_" + enddate;
    //this.applyfilter();
    let request ={
      fromDate : startdate,
      toDate : enddate,
      userId : this.userId,
      userRoleId : this.userRolesId
    }
    this.commonService.getAMCDataReport(request)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;

    });
  }

  /**
  * Name: getLeadLevelReport
  * purpose: To export report as excel
  */
  getLeadLevelReport(): void {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let startdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let enddate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let fileName = "Lead_Level_Report_From_" + startdate + "_To_" + enddate;
    //this.applyfilter();
    this.commonService.getAMCLeadLevelReport(startdate, enddate, this.selectedProductType, this.userId, this.userRolesId)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;

    });
  }

   /**
  * Name: getPipelineRegionwiseReport
  * purpose: To get piprline region wise data
  */
  getPipelineRegionwiseReport(): void{
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let startdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let enddate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let fileName = "Pipeline_Data_Report_From_" + startdate + "_To_" + enddate;
    //this.applyfilter();
    this.commonService.getPipelineRegionWiseDataReport(startdate, enddate, this.userId, this.userRolesId)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
    });
  }

  setDefaultDates() {
    const current = new Date();
    this.fromDate = new Date(current.getFullYear(), current.getMonth(), 1); // 1st of current month
    this.toDate = this.today; // Today's date
  }

  // Validate the date range to restrict to 30 days
  validateDateRange(type: 'from' | 'to') {
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    this.isDateRangeInvalid = false;
    this.fromDate = new Date(this.fromDate);
    this.toDate = new Date(this.toDate);
    if (type === 'from') {
      const maxToDate = new Date(this.fromDate.getTime() + thirtyDaysInMs);
      if (this.toDate.getTime() > maxToDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    } else if (type === 'to') {
      const minFromDate = new Date(this.toDate.getTime() - thirtyDaysInMs);
      if (this.fromDate.getTime() < minFromDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    }
  }
}
